import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { withTUXIcon } from './withTUXIcon.js';
import * as React from 'react';

function IconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor"
  }, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: props.className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3 7.75a1.01 1.01 0 00-1.49-.1l-3.07 3.01c-.98.97-1.28 2.23-.87 3.28a43.89 43.89 0 0010.24 15.34A45.04 45.04 0 0033.77 39.3c1.07.4 2.36.1 3.34-.85l3.07-3.01a.97.97 0 00-.09-1.47l-5.72-4.36a1.02 1.02 0 00-1.13-.06l-1.13.66a6.1 6.1 0 01-7.33-.88l-6.73-6.6a5.79 5.79 0 01-.9-7.17l.68-1.1a.96.96 0 00-.07-1.11L13.3 7.75zM8.99 4.89a5.07 5.07 0 017.49.45l4.45 5.61c1.26 1.6 1.4 3.8.34 5.53l-.68 1.1c-.47.78-.35 1.76.3 2.4l6.73 6.59c.64.63 1.65.75 2.44.3l1.13-.67a5.09 5.09 0 015.64.33l5.73 4.36a4.83 4.83 0 01.46 7.33l-3.07 3a7.26 7.26 0 01-7.58 1.76 49.04 49.04 0 01-17.07-10.93A47.8 47.8 0 014.13 15.32 6.91 6.91 0 015.9 7.9l3.07-3z"
  }));
}
var TUXIconPhone = withTUXIcon(IconPhone);

export default IconPhone;
export { TUXIconPhone };
